(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[694],{

/***/ 81965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var utils_hooks_useResize__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94142);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28086);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);







var Medias = function Medias(props) {
  var _ref;

  var size = (0,utils_hooks_useResize__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
  var _props$title = props.title,
      title = _props$title === void 0 ? '' : _props$title,
      _props$desc = props.desc,
      desc = _props$desc === void 0 ? '' : _props$desc,
      _props$features = props.features,
      features = _props$features === void 0 ? [] : _props$features,
      _props$bgImage = props.bgImage,
      bgImage = _props$bgImage === void 0 ? '' : _props$bgImage,
      _props$bgImageM = props.bgImageM,
      bgImageM = _props$bgImageM === void 0 ? '' : _props$bgImageM,
      _props$imgPre = props.imgPre,
      imgPre = _props$imgPre === void 0 ? '' : _props$imgPre,
      type = props.type;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().media), type === 1 && (_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().media1)),
    style: {
      backgroundImage: "url(".concat(size.width < 768 ? (_ref = "".concat(imgPre).concat(bgImageM)) !== null && _ref !== void 0 ? _ref : "".concat(imgPre).concat(bgImage) : "".concat(imgPre).concat(bgImage), ")")
    },
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
      className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().content),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().title),
        children: title
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().desc),
        dangerouslySetInnerHTML: {
          __html: desc.replace(/\n/g, '<br/>')
        }
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().features),
        children: features.map(function (item, index) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().feature),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("img", {
              src: "".concat(imgPre, "feature-icon").concat(index, ".png"),
              alt: "media"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
              className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().name),
              children: item.name
            })]
          }, item.name);
        })
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Medias);

/***/ }),

/***/ 58262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ wrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/layout/index.tsx + 6 modules
var layout = __webpack_require__(16569);
// EXTERNAL MODULE: ./src/components/product/relevance/wrapper/index.module.scss
var index_module = __webpack_require__(89262);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./src/components/tdk/index.tsx + 1 modules
var tdk = __webpack_require__(6071);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/product/relevance/nav/index.module.scss
var nav_index_module = __webpack_require__(73649);
var nav_index_module_default = /*#__PURE__*/__webpack_require__.n(nav_index_module);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/product/relevance/nav/index.tsx
/* eslint-disable react-hooks/exhaustive-deps */








var timer;

var Nav = function Nav(_ref) {
  var defaultIndex = _ref.defaultIndex,
      menu = _ref.menu,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 1 : _ref$type;

  var _useState = (0,react.useState)(defaultIndex || 0),
      current = _useState[0],
      setCurrent = _useState[1];

  var _useState2 = (0,react.useState)(false),
      sticky = _useState2[0],
      setSticky = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      once = _useState3[0],
      setOnce = _useState3[1]; //首次动画执行


  var count = (0,react.useRef)(0); // 首次动画执行占位不需要过渡效果 0初始状态 1 首次动画执行（自动滚动），其余为手动滚动

  var dom = (0,react.useRef)(null);
  var subNav = (0,react.useRef)();
  var menuRef = (0,react.useRef)(null);
  var router = (0,next_router.useRouter)();
  var onScroll = (0,react.useCallback)(function () {
    var scrollTop = document.documentElement.scrollTop;

    if (scrollTop > 100) {
      count.current++;
      setSticky(true);
      setOnce(false);
      count.current++;
    } else {
      if (count.current >= 1) {
        count.current = 2;
      }

      setSticky(false);
    }
  }, []);
  (0,react.useEffect)(function () {
    window.addEventListener('scroll', onScroll);
    return function () {
      window.removeEventListener('scroll', onScroll);
    };
  }, [onScroll]);
  (0,react.useEffect)(function () {
    if (window.innerWidth > 768) {
      setOnce(true);
      requestAnimation();
    }
  }, []);

  var requestAnimation = function requestAnimation() {
    var scrollTop = document.documentElement.scrollTop;
    var speed = scrollTop > 80 ? 1 : 2;
    timer = window.requestAnimationFrame(function () {
      if (scrollTop > 100) {
        cancelAnimationFrame(timer);
      } else {
        document.documentElement.scrollTop = scrollTop + speed;
        requestAnimation();
      }
    });
  }; // 移动端-设置当前页面导航按钮是否在可视口完全显示


  (0,react.useEffect)(function () {
    var _menuRef$current;

    var childNodes = (_menuRef$current = menuRef.current) === null || _menuRef$current === void 0 ? void 0 : _menuRef$current.childNodes;

    if (childNodes && window.innerWidth < 768) {
      var child = childNodes[current];
      var position = child.getClientRects();
      var _position$ = position[0],
          left = _position$.left,
          width = _position$.width;
      var diff = left + width - window.innerWidth;

      if (diff > 0) {
        if (menuRef.current) {
          var distance = menuRef.current.scrollLeft + diff + 10;
          menuRef.current.scrollLeft = distance;
        }
      }
    }
  }, []);

  var Goto = function Goto(index, url) {
    setCurrent(index);
    router.push(url); // window.location.href = url;
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      ref: dom,
      className: classnames_default()((nav_index_module_default()).nav__theme_parent, once && (nav_index_module_default()).once, sticky && (nav_index_module_default()).sticky),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: classnames_default()((nav_index_module_default()).logo, sticky && (nav_index_module_default()).show, !sticky && (nav_index_module_default()).hide),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: constants/* homeUrl */.hB,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: "/v2/images/login-logo.png",
            alt: "logo",
            width: "134",
            height: "27"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: classnames_default()((nav_index_module_default())["nav-pc"]),
        ref: subNav,
        children: menu.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            onClick: function onClick() {
              return Goto(index, item.link);
            },
            className: classnames_default()((nav_index_module_default())["nav-pc-item"], index === current && (nav_index_module_default()).focus),
            children: item.name
          }, item.name);
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()((nav_index_module_default()).transition, count.current === 1 && (nav_index_module_default()).once, count.current > 1 && sticky && (nav_index_module_default()).active, 'for-pc')
    }), type === 1 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (nav_index_module_default())["nav-mob"],
      ref: menuRef,
      children: menu.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          onClick: function onClick() {
            return Goto(index, item.link);
          },
          className: classnames_default()((nav_index_module_default())["nav-mob-item"], index === current && (nav_index_module_default()).focus),
          children: item.name
        }, item.name);
      })
    }), type === 2 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (nav_index_module_default())["nav-mob-2"],
      children: menu.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          onClick: function onClick() {
            return Goto(index, item.link);
          },
          className: classnames_default()((nav_index_module_default())["nav-mob-item"], index === current && (nav_index_module_default()).focus),
          children: item.name
        }, item.name);
      })
    })]
  });
};

/* harmony default export */ var nav = (Nav);
;// CONCATENATED MODULE: ./src/components/product/relevance/wrapper/index.tsx









var menu1 = [{
  name: '智能硬件',
  link: '/hardware'
}, {
  name: '软件客户端',
  link: '/client'
}];
var menu2 = [{
  name: '一体化4K终端',
  link: '/hardware/fullSceneTerminal'
}, {
  name: '小鱼云镜',
  link: '/hardware/cloudMirrorSystem'
}, {
  name: '大型终端',
  link: '/hardware/flagshipTerminal'
}, {
  name: '中型终端',
  link: '/hardware/mediumTerminal'
}, {
  name: '中小型终端',
  link: '/hardware/integratedTerminal'
}, {
  name: '智能会议平板',
  link: '/hardware/meetingBoard'
}, {
  name: '电视墙服务器',
  link: '/hardware/TVwall'
}];
var menus = {
  '1': {
    name: '云视频会议',
    menu: menu1
  },
  '2': {
    name: '智能硬件',
    menu: menu2,
    type: 2
  }
};

var Wrapper = function Wrapper(_ref) {
  var title = _ref.title,
      current = _ref.current,
      children = _ref.children,
      _ref$menuIndex = _ref.menuIndex,
      menuIndex = _ref$menuIndex === void 0 ? '1' : _ref$menuIndex,
      customClass = _ref.customClass,
      pageKey = _ref.pageKey;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(layout/* default */.Z, {
    layoutClass: (index_module_default()).layout,
    headerClass: (index_module_default()).header,
    children: [pageKey ? /*#__PURE__*/(0,jsx_runtime.jsx)(tdk/* default */.Z, {
      pageKey: pageKey
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("title", {
        children: [menus[menuIndex].name, "-", title]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
      className: classnames_default()((index_module_default()).main, customClass),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(nav, {
        menu: menus[menuIndex].menu,
        defaultIndex: current,
        type: menus[menuIndex].type || 1
      }), children]
    })]
  });
};

/* harmony default export */ var wrapper = (Wrapper);

/***/ }),

/***/ 34790:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1730);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var utils_hooks_useResize__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94142);
/* harmony import */ var components_transition__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66335);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);








var Index = function Index(props) {
  var _props$title, _ref, _props$data, _props$data2;

  var _props$animate = props.animate,
      animate = _props$animate === void 0 ? 'none' : _props$animate,
      _props$delay = props.delay,
      delay = _props$delay === void 0 ? 0 : _props$delay,
      _props$offset = props.offset,
      offset = _props$offset === void 0 ? 0 : _props$offset,
      _props$bgImg = props.bgImg,
      bgImg = _props$bgImg === void 0 ? '' : _props$bgImg,
      _props$mBgImg = props.mBgImg,
      mBgImg = _props$mBgImg === void 0 ? '' : _props$mBgImg;
  var size = (0,utils_hooks_useResize__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().scheme), props.isBg && (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().bg), props.className),
    style: {
      backgroundImage: "url(".concat(size.width < 768 ? mBgImg !== null && mBgImg !== void 0 ? mBgImg : bgImg : bgImg, ")")
    },
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_transition__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      delay: delay,
      offset: offset,
      animate: animate,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        className: 'title',
        dangerouslySetInnerHTML: {
          __html: ((_props$title = props.title) === null || _props$title === void 0 ? void 0 : _props$title.replace(/\n/g, '<br>')) || '解决方案'
        }
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_transition__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      delay: delay,
      offset: offset,
      animate: animate,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        className: 'mobTitle',
        dangerouslySetInnerHTML: {
          __html: (_ref = props.mTitle ? props.mTitle : props.title || '') === null || _ref === void 0 ? void 0 : _ref.replace(/\n/g, '<br>')
        }
      })
    }), props.noTitle && size.width < 768 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
      className: 'scheme-wrap',
      children: (_props$data = props.data) === null || _props$data === void 0 ? void 0 : _props$data.map(function (item) {
        var _item$title;

        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
          className: "scheme-item",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_transition__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            delay: delay + 0.3,
            offset: offset,
            animate: animate,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
              style: {
                backgroundImage: "url(".concat(item.mUrl, ")")
              },
              className: "img-wrapper-m"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_transition__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            delay: delay + 0.6,
            offset: offset,
            animate: animate,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
              className: "scheme-item-title",
              dangerouslySetInnerHTML: {
                __html: (_item$title = item.title) === null || _item$title === void 0 ? void 0 : _item$title.replace(/\n/g, '<br>')
              }
            })
          })]
        }, item.title);
      })
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
      className: "content grid-".concat(props.type),
      children: (_props$data2 = props.data) === null || _props$data2 === void 0 ? void 0 : _props$data2.map(function (item) {
        var _item$mUrl, _item$title2, _ref2, _item$desc;

        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
          className: "scheme-item",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(components_transition__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            delay: delay + 0.3,
            offset: offset,
            animate: animate,
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("img", {
              src: item.pcUrl,
              className: "img-wrapper",
              alt: ""
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("img", {
              src: (_item$mUrl = item.mUrl) !== null && _item$mUrl !== void 0 ? _item$mUrl : item.pcUrl,
              className: "img-wrapper-m",
              alt: ""
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_transition__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            delay: delay + 0.6,
            offset: offset,
            animate: animate,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
              className: "scheme-item-content",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('scheme-item-title', 'for-pc'),
                dangerouslySetInnerHTML: {
                  __html: (_item$title2 = item.title) === null || _item$title2 === void 0 ? void 0 : _item$title2.replace(/\n/g, '<br>')
                }
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('scheme-item-title', !item.desc && 'scheme-item-title-normal', 'for-mobile'),
                dangerouslySetInnerHTML: {
                  __html: (_ref2 = item.mTitle ? item.mTitle : item.title || '') === null || _ref2 === void 0 ? void 0 : _ref2.replace(/\n/g, '<br>')
                }
              }), item.desc && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
                className: "scheme-item-desc",
                dangerouslySetInnerHTML: {
                  __html: (_item$desc = item.desc) === null || _item$desc === void 0 ? void 0 : _item$desc.replace(/\n/g, '<br>')
                }
              })]
            })
          })]
        }, item.title);
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Index);

/***/ }),

/***/ 48617:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _workspace_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var components_contact__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53784);
/* harmony import */ var components_product_relevance_wrapper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58262);
/* harmony import */ var components_product_banner_multiple__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12221);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(93990);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var components_medias__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(81965);
/* harmony import */ var components_product_scheme__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34790);
/* harmony import */ var components_transition__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(66335);
/* harmony import */ var components_product_banner__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31016);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_workspace_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * 中型终端
 */













var IMG_PRE = 'https://sdk-source.xylink.com/website/assets/hardware/hard/ME60S/';
var bannerList = [{
  title: '中型会议室\n分体式终端',
  pcUrl: 'bg0.jpg',
  mUrl: 'm/bg0.jpg',
  desc: '4K超高清画面，有效控制利旧成本，轻松升级视频会议体验',
  mDesc: '4K超高清画面，有效控制利旧成本，轻松升级\n视频会议体验',
  type: 4,
  className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().firstBanner)
}, {
  title: '稳定流畅，性能优异',
  pcUrl: 'bg1.jpg',
  mUrl: 'm/bg1.jpg',
  desc: '国产芯片，支持H.265 SVC编解码\n前向纠错、丢包重传、丢包保护\n随时发起视频会议，运行超强稳定',
  type: 3,
  className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().banner1)
}, {
  title: '4K超清，清晰如面聊',
  pcUrl: 'bg2.jpg',
  mUrl: 'm/bg2.jpg',
  desc: '4K超高清显示，画质细腻精致，清晰呈现每个细节\n支持屏幕共享和批注显示，异地协作更轻松',
  mDesc: '4K超高清显示，画质细腻精致，清晰呈现每个\n细节\n支持屏幕共享和批注显示，异地协作更轻松',
  type: 4
}, {
  title: '无限扩展，轻松升级',
  pcUrl: 'bg3.jpg',
  mUrl: 'm/bg3.jpg',
  desc: '支持主流云视频会议平台，麦克风、摄像头按需扩展\n满足利旧升级，无需过多改造，轻松升级视频会议体验',
  mDesc: '支持主流云视频会议平台，麦克风、摄像头按\n需扩展\n满足利旧升级，无需过多改造，轻松升级视频\n会议体验',
  type: 3,
  className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().banner2)
}, {
  title: '全方位拾音，远端听讲“声”临其境',
  mTitle: '全方位拾音\n远端听讲“声”临其境',
  pcUrl: 'bg4.jpg',
  mUrl: 'm/bg4.jpg',
  desc: '实现全方位拾音，搭配智能降噪、消除回声、自动增益等算法\n本地会议发言精准捕捉，远端听讲不遗漏关键信息',
  mDesc: '实现全方位拾音，搭配智能降噪、消除回声、\n自动增益等算法\n本地会议发言精准捕捉，远端听讲不遗漏关键\n信息',
  type: 4,
  className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().banner3)
}];
var features = [{
  name: '声音'
}, {
  name: '视频'
}, {
  name: '控制'
}, {
  name: '信令'
}, {
  name: '网络'
}, {
  name: '电源'
}];
var scene = [{
  title: '中型会议室商务洽谈',
  pcUrl: IMG_PRE + 'scene-img0.jpg'
}, {
  title: '分支机构远程协同',
  pcUrl: IMG_PRE + 'scene-img1.jpg'
}, {
  title: '高效学习培训',
  pcUrl: IMG_PRE + 'scene-img2.jpg'
}, {
  title: '日常智慧党建',
  pcUrl: IMG_PRE + 'scene-img3.jpg'
}];
var scheme = [{
  title: '支持双屏',
  pcUrl: IMG_PRE + 'scheme-img0.jpg'
}, {
  title: '支持单屏',
  pcUrl: IMG_PRE + 'scheme-img1.jpg'
}];

var Me90 = function Me90() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(components_product_relevance_wrapper__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    title: "\u4E2D\u578B\u7EC8\u7AEF",
    menuIndex: "2",
    current: 3,
    customClass: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().me60s),
    children: [bannerList.map(function (item) {
      return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(components_product_banner_multiple__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, _objectSpread(_objectSpread({}, item), {}, {
        animate: 'fadeIn',
        delay: 0.5,
        descCenter: true,
        key: item.title,
        imageHost: IMG_PRE,
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().banner), item.className)
      }));
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(components_medias__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
      title: '极简部署，自由布线',
      desc: '多媒体总线技术，音频、视频、控制、信令、\n网络、电源六流合一\n轻部署方式，布线便捷，网线连接扩展自由',
      features: features,
      imgPre: IMG_PRE,
      bgImage: 'bg5.jpg',
      bgImageM: 'm/bg5.jpg'
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(components_product_banner__WEBPACK_IMPORTED_MODULE_9__/* .WrapperBanner */ .G, {
      bannerInfo: {
        pcUrl: IMG_PRE + 'bg6.jpg',
        mUrl: IMG_PRE + 'm/bg6.jpg',
        classNames: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().scheme)
      },
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default()["scheme-content"]),
        children: scheme.map(function (item) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default()["scheme-item"]),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(components_transition__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("p", {
                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default()["scheme-item-title"]),
                children: item.title
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(components_transition__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("img", {
                className: 'for-pc',
                src: item.pcUrl,
                alt: ""
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(components_transition__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("img", {
                className: 'for-mobile',
                src: item.pcUrl,
                alt: ""
              })
            })]
          }, item.title);
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(components_product_scheme__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
      animate: "fadeIn",
      delay: 0.5,
      data: scene,
      title: '应用场景',
      className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().scene)
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(components_contact__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().contact)
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (Me90);

/***/ }),

/***/ 86240:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hardware/mediumTerminal",
      function () {
        return __webpack_require__(48617);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 28086:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"border__px":"medias_border__px__BOhua","border__px-before":"medias_border__px-before__RZloI","border__px-before1":"medias_border__px-before1__DQY85","border-children1":"medias_border-children1__rTtSZ","border-children2":"medias_border-children2__TcDDQ","for-mobile":"medias_for-mobile__iwzwX","for-pc":"medias_for-pc__C9i_e","media":"medias_media__Idg9d","content":"medias_content__aDFN9","title":"medias_title__DMzzX","desc":"medias_desc__z9mzi","features":"medias_features__6_YAa","feature":"medias_feature__h6aQ9","name":"medias_name__HICDw","media1":"medias_media1__8MYTE"};

/***/ }),

/***/ 73649:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"border__px":"nav_border__px__LnplE","border__px-before":"nav_border__px-before__EVov9","border__px-before1":"nav_border__px-before1__2oD1e","border-children1":"nav_border-children1__g0F3X","border-children2":"nav_border-children2__DnnSf","for-mobile":"nav_for-mobile__ZciXU","for-pc":"nav_for-pc__z_KI0","nav__theme_parent":"nav_nav__theme_parent__T4U4O","logo":"nav_logo__WR8zR","show":"nav_show__4YtHP","nav-pc":"nav_nav-pc__bFsJ0","nav-pc-item":"nav_nav-pc-item__kYYYW","focus":"nav_focus__ByYUr","once":"nav_once__aksOZ","sticky":"nav_sticky__l7SSZ","transition":"nav_transition__B1wHH","active":"nav_active__1D68f","nav-mob":"nav_nav-mob__FuCYJ","nav-mob-2":"nav_nav-mob-2__6Mv2f","nav-mob-item":"nav_nav-mob-item__6k_Rb"};

/***/ }),

/***/ 89262:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"border__px":"wrapper_border__px__F6VvU","border__px-before":"wrapper_border__px-before__Mxpn1","border__px-before1":"wrapper_border__px-before1__EFvO6","border-children1":"wrapper_border-children1__KmKjR","border-children2":"wrapper_border-children2__7Jboy","for-mobile":"wrapper_for-mobile__2kveH","for-pc":"wrapper_for-pc__yuzrw","layout":"wrapper_layout__j4SAy","header":"wrapper_header__l9dYm"};

/***/ }),

/***/ 1730:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"border__px":"scheme_border__px__p2mre","border__px-before":"scheme_border__px-before__Z5zYd","border__px-before1":"scheme_border__px-before1__85u3k","border-children1":"scheme_border-children1__3YAlL","border-children2":"scheme_border-children2__7mE0p","for-mobile":"scheme_for-mobile___ycZS","for-pc":"scheme_for-pc__UIzZn","scheme":"scheme_scheme__rxdlU","bg":"scheme_bg__bVFmx"};

/***/ }),

/***/ 93990:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"border__px":"mediumTerminal_border__px__zl_ut","border__px-before":"mediumTerminal_border__px-before__zo5ob","border__px-before1":"mediumTerminal_border__px-before1__1YGqL","border-children1":"mediumTerminal_border-children1__EWFCl","border-children2":"mediumTerminal_border-children2__B8D54","for-mobile":"mediumTerminal_for-mobile__Id7ug","for-pc":"mediumTerminal_for-pc__gQBXD","hardware":"mediumTerminal_hardware__Bp10b","contentWrapper":"mediumTerminal_contentWrapper__2RKni","header":"mediumTerminal_header__VBdHK","bigTitle":"mediumTerminal_bigTitle__m1s6x","arrowImg":"mediumTerminal_arrowImg__V6Azy","horizontal":"mediumTerminal_horizontal__V5Uj5","totalBanner":"mediumTerminal_totalBanner__FJ_Yq","banner":"mediumTerminal_banner__dcEyo","title":"mediumTerminal_title__3Zybx","desc":"mediumTerminal_desc__49XCK","knowMore":"mediumTerminal_knowMore__69ykd","contact":"mediumTerminal_contact__Ybbpd","me60s":"mediumTerminal_me60s__a9mEe","firstBanner":"mediumTerminal_firstBanner__Zzn08","banner1":"mediumTerminal_banner1___nc9p","banner2":"mediumTerminal_banner2__JothE","scheme":"mediumTerminal_scheme__P4onk","scheme-content":"mediumTerminal_scheme-content__TwwQ2","scheme-item":"mediumTerminal_scheme-item__BIfBW","scheme-item-title":"mediumTerminal_scheme-item-title__tkTSh","scene":"mediumTerminal_scene__gpQFD","banner3":"mediumTerminal_banner3__ONpQN"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9243,9092,9774,2888,179], function() { return __webpack_exec__(86240); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);